import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import getMetrics from './getMetrics';
import { filterMetricsForTotals } from './filterMetricsForTotals';
import getLimitSetKeywordFilter from '../getLimitSetKeyworkFilter';

const getTopNTermsResponses = async ({
  chartDef,
  filterInput,
  usedMetrics,
  isDashboardGadget,
  currentDateScope,
  previousDateScope,
  toMetricInput,
  client,
  groupByField,
  comparison,
}: {
  chartDef: V5ChartDefinition;
  filterInput: FilterInput;
  usedMetrics: Metrics.Metric[];
  isDashboardGadget?: boolean;
  currentDateScope: DateRangeInput;
  comparison?: PersistedComparisonType;
  previousDateScope: DateRangeInput;
  toMetricInput: (metric: Metrics.NormalMetric | MetricInput) => MetricInput;
  client: ApolloClient<NormalizedCacheObject>;
  groupByField: string;
}) => {
  const groupedMetricsRequest = await getMetrics({
    chartDef,
    filterInput,
    usedMetrics,
    isDashboardGadget,
    dateScope: currentDateScope,
    toMetricInput,
    client,
  });

  const limitedKeywordFilter = getLimitSetKeywordFilter(
    groupedMetricsRequest,
    groupByField,
    chartDef.dimensionA,
  );

  const groupedMetricsComparisonRequest =
    comparison && chartDef.series.some((s) => !!s.matrixCellType)
      ? getMetrics({
          chartDef,
          filterInput,
          usedMetrics,
          isDashboardGadget,
          dateScope: previousDateScope,
          toMetricInput,
          client,
          limitedKeywordFilter,
        })
      : Promise.resolve([]);
  const totalsMetrics = filterMetricsForTotals({ usedMetrics, chartDef });
  const totalsRequest =
    totalsMetrics.length > 0
      ? getMetrics({
          chartDef,
          filterInput,
          getTotals: true,
          usedMetrics: totalsMetrics,
          isDashboardGadget,
          dateScope: currentDateScope,
          toMetricInput,
          client,
          limitedKeywordFilter,
        })
      : Promise.resolve([]);
  const totalsComparisonRequest =
    comparison &&
    chartDef.series.some((s) => !!s.matrixCellType) &&
    totalsMetrics.length > 0
      ? getMetrics({
          chartDef,
          filterInput,
          getTotals: true,
          usedMetrics: totalsMetrics,
          isDashboardGadget,
          dateScope: previousDateScope,
          toMetricInput,
          client,
          limitedKeywordFilter,
        })
      : Promise.resolve([]);

  const responses = await Promise.all([
    groupedMetricsRequest,
    totalsRequest,
    groupedMetricsComparisonRequest,
    totalsComparisonRequest,
  ]);

  return responses;
};

export default getTopNTermsResponses;
